// src/config.js
export const API_BASE_URL = 'https://soulmaintapi.egyptiot.com';


// export const API_BASE_URL = 'http://localhost:3000';
